import { textWithinLimit } from '@/shared/lib/validation';
import { z } from 'zod';
import { CHAT_DIALOG_MESSAGE_MAX_LENGTH, CHAT_PHOTO_CAPTION_MAX_LENGTH } from './sendMessageSchema';

/** Проверяет текст правки с учётом сохранённых вложений */
export const createChatMessageEditSchema = (hasPhotos: boolean) => z.object({
    text: textWithinLimit(hasPhotos
        ? CHAT_PHOTO_CAPTION_MAX_LENGTH
        : CHAT_DIALOG_MESSAGE_MAX_LENGTH,
        'Текст превышает допустимую длину', { trim: true })
        .refine((text) => hasPhotos || Boolean(text),
            'Напишите сообщение или оставьте фотографию'),
});
